/* tslint:disable */
/* eslint-disable */
/**
 * Keyops CEP
 * Customer Engagement Platform API documentation
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import globalAxios, { AxiosResponse, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { CreateEvaluationEventDto } from '../models';
import { EvaluationEvent } from '../models';
/**
 * ExternalApi - axios parameter creator
 * @export
 */
export const ExternalApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Test whether or not HMAC authentication is working
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalControllerHmacTest: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/external/hmac-test`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Push EvaluationEvents
         * @param {CreateEvaluationEventDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalControllerPushEvents: async (body: CreateEvaluationEventDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling externalControllerPushEvents.');
            }
            const localVarPath = `/api/external/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExternalApi - functional programming interface
 * @export
 */
export const ExternalApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Test whether or not HMAC authentication is working
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalControllerHmacTest(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await ExternalApiAxiosParamCreator(configuration).externalControllerHmacTest(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Push EvaluationEvents
         * @param {CreateEvaluationEventDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalControllerPushEvents(body: CreateEvaluationEventDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<Array<EvaluationEvent>>>> {
            const localVarAxiosArgs = await ExternalApiAxiosParamCreator(configuration).externalControllerPushEvents(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ExternalApi - factory interface
 * @export
 */
export const ExternalApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Test whether or not HMAC authentication is working
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalControllerHmacTest(options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return ExternalApiFp(configuration).externalControllerHmacTest(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Push EvaluationEvents
         * @param {CreateEvaluationEventDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalControllerPushEvents(body: CreateEvaluationEventDto, options?: AxiosRequestConfig): Promise<AxiosResponse<Array<EvaluationEvent>>> {
            return ExternalApiFp(configuration).externalControllerPushEvents(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExternalApi - object-oriented interface
 * @export
 * @class ExternalApi
 * @extends {BaseAPI}
 */
export class ExternalApi extends BaseAPI {
    /**
     * 
     * @summary Test whether or not HMAC authentication is working
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalApi
     */
    public async externalControllerHmacTest(options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return ExternalApiFp(this.configuration).externalControllerHmacTest(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Push EvaluationEvents
     * @param {CreateEvaluationEventDto} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalApi
     */
    public async externalControllerPushEvents(body: CreateEvaluationEventDto, options?: AxiosRequestConfig) : Promise<AxiosResponse<Array<EvaluationEvent>>> {
        return ExternalApiFp(this.configuration).externalControllerPushEvents(body, options).then((request) => request(this.axios, this.basePath));
    }
}
